import React from 'react';
import Header from '../header/Header';
import Footer from '../footer/Footer';
import FourZeroFour from '../../assets/images/four-zero-four.svg'
import './notFound.scss'
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <>
    <Header/>
    <div className='main-container'>
      <div className='container-wrap'>
       <div className='not-found-wrap'>
        <div className='img-wrap'>
          <img src={FourZeroFour} alt='404' />
        </div>
        <div className='not-found-content'>
          <div className='not-found-title'>Oops page not found</div>
          <div>The page you are looking for might have been removed had its name changed or temporality unavailable</div>
          <div className='btn-wrap'><Button variant='primary' onClick={()=>navigate('/')}>Go Home</Button></div>
        </div>
       </div>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default NotFound;